import { render, staticRenderFns } from "./PreviousAddress.vue?vue&type=template&id=6926f7d1&"
import script from "./PreviousAddress.vue?vue&type=script&lang=js&"
export * from "./PreviousAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports